export default {
  JOURNEYS (state) {
    return state.journeys
  },
  JOURNEY (state) {
    return state.journey
  },
  NODES (state) {
    return state.nodes
  },
  SELECTED_NODE (state) {
    if (!state.selectedNodeId) return null
    return state.nodes.find(n => (n.id || n._tempId) === state.selectedNodeId) || null
  },
  MAIN_FLOW_NODES (state) {
    return state.nodes.filter(n => !n.parent_node_id)
  },
  BRANCH_NODES: (state) => (parentNodeId, branchType) => {
    return state.nodes.filter(n => n.parent_node_id === parentNodeId && n.branch_type === branchType)
  }
}
